export const elHTML = document.documentElement;
export const standardListener = 'click';
export const eventTypes = {

  transform: [

    'transform',
    '-webkit-transform',
    '-ms-transform'
  ],
  transitionEnd: [

    'webkitTransitionEnd',
    'transitionend',
    'msTransitionEnd',
    'oTransitionEnd'
  ]
};

/* export const grunticonFiles = [

  ( window.assetsBaseUrl || '' ) + 'img/icons/icons.data.svg.css',
  ( window.assetsBaseUrl || '' ) + 'img/icons/icons.data.png.css',
  ( window.assetsBaseUrl || '' ) + 'img/icons/icons.fallback.css'
]; */
